import { render, staticRenderFns } from "./LeituraHotel.vue?vue&type=template&id=4ed0eb16&scoped=true&class=template&"
import script from "./LeituraHotel.vue?vue&type=script&lang=js&"
export * from "./LeituraHotel.vue?vue&type=script&lang=js&"
import style0 from "./LeituraHotel.vue?vue&type=style&index=0&id=4ed0eb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0eb16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
